import { useTranslation } from 'react-i18next';
import { ApiError } from '../api.ts';

export function useErrorText() {
  const { t } = useTranslation();
  return (err: unknown): string => {
    if (err instanceof ApiError)
      return t(`errors.${err.code}`, { defaultValue: t('errors.internal') });
    return t('errors.internal');
  };
}

export function ErrorText({ error }: { error: unknown }) {
  const text = useErrorText();
  if (!error) return null;
  return (
    <p className="err" role="alert">
      {text(error)}
    </p>
  );
}
